import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Data payload for removing an AVP dashboard element.
 */
export type AvpDashboardRemoveElementData = {
	/**
	 * The ARI of the AVP dashboard to remove the element from.
	 */
	dashboardAri: string;
	/**
	 * The identifier of the element to remove.
	 */
	elementId: string;
	/**
	 * The canvas layout configuration after the element has been removed.
	 */
	canvasLayout: SerializableValue;
};

/**
 * Properties for the AVP dashboard element removal command.
 *
 * @extends CommandProperties
 */
export interface AvpDashboardRemoveElementCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the element removal request.
	 */
	key: string;
	/**
	 * The data payload containing the element identifier.
	 */
	data: AvpDashboardRemoveElementData;
}

/**
 * A command sent by a bridge API client to remove an element from an AVP dashboard.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to remove an AVP dashboard element with the specified identifier.
 */
export const AvpDashboardRemoveElementCommand: CommandConstructor<
	AvpDashboardRemoveElementCommandProperties,
	SerializableValue
> = createCommand<AvpDashboardRemoveElementCommandProperties>('avp_dashboard_remove_element');
